import Alpine from "alpinejs"
import Swiper from "swiper"
import { EffectFade } from "swiper/modules"

// import 'swiper/css/pagination';

Alpine.data('HistorySwiper', () => ({
    currentIndex: 0,
    swiper: null,
    underline: null,
    tabs: null,
    init(){
        this.swiper = new Swiper(this.$el.querySelector('.historySwiper'), {
            modules: [EffectFade],
            effect: 'fade',
            fadeEffect: {
                crossFade: true
            },
            slidesPerView: 1,
            allowTouchMove: false,
            slideFullyVisibleClass: '!h-fit'
        });

        this.underline = this.$refs.underline;
        this.tabs = this.$refs.tabs;

        this.moveUnderline();
        this.bindEvents();
    },
    bindEvents(){
        if(this.swiper){
            this.swiper.on('slideChange', () => {
                this.currentIndex = this.swiper.activeIndex;
    
                this.moveUnderline();
            })
        }
    },
    setIndex(index){
        this.currentIndex = index;
        this.swiper.slideTo(index);
    },
    moveUnderline(){
        this.tabs = this.$refs.tabs;
        let currentTab = this.tabs.children[this.currentIndex];

        this.underline.style.width = currentTab.offsetWidth + 'px';
        this.underline.style.left = currentTab.offsetLeft + 'px';
    }
}))